import { useEffect } from "react";
import { useNavigate } from "react-router";
import { FolderChatStatus } from "~/api/model";
import { useGetProject } from "~/api/projects/projects";
import { useGetCurrentUser } from "~/api/users/users";
import { NotFound } from "~/components/NotFound";
import { PageLayout } from "~/components/PageLayout";
import { DocumentsList } from "~/features/case/components/list/DocumentsList";
import { SupportiveMaterialsModal } from "~/features/cases/components/SupportiveMaterialsModal";
import { CasePageTour } from "~/features/onboarding";
import { ROUTES, useProjectParams } from "~/helpers";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";

export const CasePage = () => {
  useTrackPageVisit("app/case/visit");
  const { organizationId, caseId } = useProjectParams();
  const { data: project, isError: isProjectError } = useGetProject(
    organizationId,
    caseId
  );
  const navigate = useNavigate();
  const { data: userInfo } = useGetCurrentUser();

  const isTourReady = project?.chatStatus === FolderChatStatus.COMPLETE;

  useEffect(() => {
    if (userInfo?.guestInOrganizations?.includes(organizationId)) {
      navigate(ROUTES.ACCESS_DENIED);
    }
  }, [userInfo, navigate, organizationId]);

  if (isProjectError) {
    return <NotFound backRoute={ROUTES.CASES({ organizationId })} />;
  }

  return (
    <PageLayout>
      <CasePageTour isReady={isTourReady} />
      <SupportiveMaterialsModal />
      <DocumentsList />
    </PageLayout>
  );
};
